import { ApolloProvider } from '@apollo/client/react';
import { type ReactNode, useMemo } from 'react';

import {
  type ApolloClientConfig,
  createApolloClient,
} from './createApolloClient';

type Props = {
  children: ReactNode;
  config?: ApolloClientConfig;
};

export function ApolloClientProvider({ children, config }: Props) {
  // Intentionally only create the client once on mount — config changes
  // should not recreate the client (same behavior as the existing providers).
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const client = useMemo(() => createApolloClient(config), []);

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
}
